import React, { useState, useEffect } from 'react';
import './CSS/Dashboard.css';

const ManageLauncherSettings = ({ backendUrl, resetKey }) => {
  const [settings, setSettings] = useState({
    titleText: 'IntoReality VR Launcher',
    titleColorStart: '#00f2fe',
    titleColorEnd: '#4facfe',
    titleFontSize: 3,
    titleMarginTop: 0,
    titleMarginBottom: 2.5,
    backgroundGradientStart: '#1a1a2e',
    backgroundGradientEnd: '#0f0f1d',
    playButtonColorStart: '#00f2fe',
    playButtonColorEnd: '#4facfe'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, [resetKey]);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${backendUrl}/launcher-settings`, {
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings({
          titleText: data.settings.titleText || 'VR Launcher',
          titleColorStart: data.settings.titleColorStart || '#00f2fe',
          titleColorEnd: data.settings.titleColorEnd || '#4facfe',
          titleFontSize: !isNaN(parseFloat(data.settings.titleFontSize)) ? parseFloat(data.settings.titleFontSize) : 3,
          titleMarginTop: !isNaN(parseFloat(data.settings.titleMarginTop)) ? parseFloat(data.settings.titleMarginTop) : 0,
          titleMarginBottom: !isNaN(parseFloat(data.settings.titleMarginBottom)) ? parseFloat(data.settings.titleMarginBottom) : 2.5,
          backgroundGradientStart: data.settings.backgroundGradientStart || '#1a1a2e',
          backgroundGradientEnd: data.settings.backgroundGradientEnd || '#0f0f1d',
          playButtonColorStart: data.settings.playButtonColorStart || '#00f2fe',
          playButtonColorEnd: data.settings.playButtonColorEnd || '#4facfe',
        });
      }
    } catch (err) {
      console.error('Error fetching launcher settings:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ 
      ...prev, 
      [name]: value 
    }));
  };

  const saveSettings = async () => {
    const token = localStorage.getItem('auth-token');
    try {
      const response = await fetch(`${backendUrl}/launcher-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': token,
        },
        body: JSON.stringify(settings),
      });
      const data = await response.json();
      if (data.success) {
        alert('Launcher settings saved successfully!');
      } else {
        alert('Error saving settings: ' + data.message);
      }
    } catch (err) {
      console.error('Error saving settings:', err);
      alert('Error saving settings');
    }
  };

  if (loading) return <div>Loading settings...</div>;

  return (
    <div className="form-group" style={{maxWidth: '600px'}}>
      <h2>Manage Launcher Settings</h2>

      <label>Title Text</label>
      <input type="text" name="titleText" value={settings.titleText} onChange={handleChange} />

      <label>Title Gradient Start (and Glow)</label>
      <input type="color" name="titleColorStart" value={settings.titleColorStart} onChange={handleChange} style={{padding:0, height:'40px', cursor:'pointer', width: '100%'}}/>

      <label>Title Gradient End</label>
      <input type="color" name="titleColorEnd" value={settings.titleColorEnd} onChange={handleChange} style={{padding:0, height:'40px', cursor:'pointer', width: '100%'}}/>

      <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Title Size (rem)</label>
          <input type="number" step="0.1" name="titleFontSize" value={settings.titleFontSize !== '' && !isNaN(settings.titleFontSize) ? settings.titleFontSize : ''} onChange={handleChange} />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Margin Top (rem)</label>
          <input type="number" step="0.1" name="titleMarginTop" value={settings.titleMarginTop !== '' && !isNaN(settings.titleMarginTop) ? settings.titleMarginTop : ''} onChange={handleChange} />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Margin Bot (rem)</label>
          <input type="number" step="0.1" name="titleMarginBottom" value={settings.titleMarginBottom !== '' && !isNaN(settings.titleMarginBottom) ? settings.titleMarginBottom : ''} onChange={handleChange} />
        </div>
      </div>

      <label>Background Gradient Start</label>
      <input type="color" name="backgroundGradientStart" value={settings.backgroundGradientStart} onChange={handleChange} style={{padding:0, height:'40px', cursor:'pointer', width: '100%'}}/>

      <label>Background Gradient End</label>
      <input type="color" name="backgroundGradientEnd" value={settings.backgroundGradientEnd} onChange={handleChange} style={{padding:0, height:'40px', cursor:'pointer', width: '100%'}}/>

      <label>Play Button Hover Gradient Start</label>
      <input type="color" name="playButtonColorStart" value={settings.playButtonColorStart} onChange={handleChange} style={{padding:0, height:'40px', cursor:'pointer', width: '100%'}}/>

      <label>Play Button Hover Gradient End</label>
      <input type="color" name="playButtonColorEnd" value={settings.playButtonColorEnd} onChange={handleChange} style={{padding:0, height:'40px', cursor:'pointer', width: '100%'}}/>

      <button onClick={saveSettings} style={{marginTop: '20px'}}>Save Settings</button>
    </div>
  );
};

export default ManageLauncherSettings;